import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { ShareAction } from '#src/app/shared/hooks/share';
import { useTrackView } from '#src/app/shared/hooks/tracking';

import type { PetitionShareChannel } from '../usePetitionShare';

import { shareActionsToEventProps } from './shared/channels';

export function useShareTracking(shareActions: ReadonlyArray<ShareAction<PetitionShareChannel>>): void {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	useTrackView('share_petition_view', {
		petition_id: `petition_${id}`,
		source_location: 'petitions_show_components_action_panel_wrapper',
		view_context: 'petitions_show',
		...shareActionsToEventProps(shareActions),
	});
}
